export default __webpack_public_path__ + "static/media/Gmail.e170b065.png";